<template>
  <div
    class="lpIndex lpIndex1 lpIndex--1 lp-section width-expand min-height-page overflow-hidden"
    :class="`bg-${backgroundColor} c-${titleColor}`"
    :id="`LpIndex1-${pageUid}`">
    <div
      class="full-bg overflow-hidden fixed z-level-1 width-expand height-expand">
      <div class="circle circle--1"></div>
      <div class="circle circle--2"></div>
      <div class="circle circle--3"></div>
    </div>

    <div class="logo-holder relative z-level-2" v-if="logo.show">
      <a
        v-if="isNonEmptyString(logo.action)"
        :href="logo.href"
        @click.prevent="
          track('lpIndex1|logo|click', { value: logo.alt }).then(
            logo.navigationHandler
          )
        ">
        <img v-bind="logo" :src="logo.finalSrc" :alt="logo.alt" />
      </a>
      <img
        v-else
        @click.prevent="
          track('lpIndex1|logo|click', { value: logo.alt }).then(
            logo.navigationHandler
          )
        "
        v-bind="logo"
        :src="logo.finalSrc"
        :alt="logo.alt" />
    </div>
    <div
      class="container container-s padding-max-bottom flex flex-column flex-middle flex-center text-center relative z-level-2">
      <div class="titles">
        <h1
          v-if="isNonEmptyString(title)"
          :class="`c-${titleColor}`"
          class="title margin-auto-horizontal">
          {{ title }}
        </h1>
        <div
          class="sub-title"
          v-if="isNonEmptyString(subTitle)"
          :class="`c-${subTitleColor}`">
          <p>
            {{ subTitle }}
          </p>
        </div>
      </div>

      <div class="options width-expand">
        <div
          class="options-title bold margin-xl-bottom"
          v-if="isNonEmptyString(itemTitle)"
          :class="`c-${itemTitle}`">
          <span>{{ itemTitle }}</span>
        </div>

        <div class="options-container flex-stretch width-expand">
          <a
            v-for="item of items"
            :class="`bg-${itemBackgroundColor} c-${itemTextColor}`"
            @click.prevent="
              track('lpIndex|mainItem|click', { value: item.text }).then(
                navigateToItem(item)
              )
            "
            class="block option min-height border-radius-m l:border-radius-l"
            :href="item.link">
            <div class="item-icon">
              <img
                :src="item.image"
                :alt="t('lp.sections.lpIndex1.itemImageAlt')" />
            </div>
            <form-button class="bold m:visible" :theme="itemButtonColor">
              {{ item.buttonText }}
            </form-button>
            <div :class="`c-${itemTextColor}`" class="option__text m:visible">
              <span>{{ item.text }}</span>
            </div>

            <div class="option__content m:hidden">
              <form-button class="bold m:hidden" :theme="itemButtonColor">
                {{ item.buttonText }}
              </form-button>
              <div :class="`c-${itemTextColor}`" class="option__text m:hidden">
                <span>{{ item.text }}</span>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="container container-xs legal margin-max-top text-center">
        <div id="legal-0" class="legal" style="">
          <p :class="`c-${legalTextColor}`" class=" text-xs line-height-110">
            {{ legalText }}
            <span v-if="legalLink.show">
              <span>&nbsp;</span>
              <a v-bind="legalLink" :class="`c-${legalLinkColor}`">{{
                legalLink.text
              }}</a>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      logo: {},
      title: "",
      subTitle: "",
      itemTitle: "",
      items: [
        {
          image: "",
          buttonText: "",
          text: "",
        },
      ],
      legalText: "",
      legalLink: {},
      backgroundColor: "",
      titleColor: "",
      subTitleColor: "",
      itemTitleColor: "",
      itemBackgroundColor: "",
      itemButtonColor: "",
      itemTextColor: "",
      legalTextColor: "",
      legalLinkColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    navigateToItem(item) {
      console.log("do navigate", item);
      if (this.isNonEmptyString(item.link)) {
        window.location.href = this.sanitizeUrl(item.link)
      }

    }
  },
};
</script>

<style scoped lang="scss">
.lpIndex1 {
  min-height: 100vh;

  .logo-holder {
    top: 0;
    inset-inline-start: 0;
    padding-inline: var(--margin-2xl);
    padding-top: var(--margin-2xl);

    img {
      --base-logo-w: 78px;
      --base-logo-h: 32px;

      width: calc(var(--base-logo-w) * 1.5);
      height: calc(var(--base-logo-h) * 1.5);
    }

    @media (max-width: 1024px) {
      padding-inline: var(--container-gutter);
      padding-top: var(--margin-2xl);
      padding-bottom: var(
        --margin-xl
      ); // the text below had internal margin, this makes it look centered
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(var(--base-logo-w) * 1.3);
      height: calc(var(--base-logo-h) * 1.3);
    }
  }

  .circle {
    position: absolute;
    z-index: 0;
    border: 2px solid var(--c-bg);
    opacity: 0.2;
    border-radius: 50%;

    @media (max-width: 1024px) {
      display: none;
    }

    &--1 {
      top: 0;
      margin-top: -270px;
      inset-inline-start: 20%;
      transform: rotate(30deg);
      transform-origin: bottom;
      height: 330px;
      width: 330px;
    }

    &--2 {
      top: 15%;
      inset-inline-end: 0;
      margin-inline-end: -300px;
      height: 480px;
      width: 480px;
    }

    &--3 {
      bottom: 0;
      inset-inline-start: 0;
      height: 480px;
      width: 480px;
      margin-bottom: -300px;
      margin-inline-start: -300px;
      transform: rotate(30deg);
      transform-origin: top;
    }
  }

  .titles {
    margin-bottom: var(--margin-xl);

    @media (max-width: 767px) {
      font-size: var(--font-l);
    }
  }

  .title {
    font-size: 60px;
    font-weight: 700;
    margin-bottom: var(--margin-m);
    max-width: 600px;
    line-height: 1;

    @media (max-width: 767px) {
      font-size: var(--font-3xl);
      margin-bottom: var(--margin-s);
    }
  }

  .sub-title {
    font-size: var(--font-3xl);
    margin-bottom: 0;

    p {
      font-size: var(--font-3xl);
      margin-bottom: 0;
    }

    @media (max-width: 767px) {
      font-size: var(--font-xl);

      p {
        font-size: var(--font-xl);
      }
    }
  }

  .achievements {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--margin-xl);
    font-size: var(--text-xl);
    margin-bottom: var(--margin-max);

    @media (max-width: 1024px) {
      font-size: var(--font-l);
      margin-bottom: var(--margin-2xl);
    }

    // notice: smaller than M not L!
    @media (max-width: 767px) {
      gap: var(--margin-m);
    }
  }

  .achievement {
    font-weight: bold;
    padding: 0 var(--margin-l) var(--margin-m) var(--margin-l);
    border-bottom: 3px dashed var(--c-lead);
    flex: 0 0 auto;
    font-size: var(--font-xl);

    @media (max-width: 1024px) {
      .text2 {
        font-weight: normal;
      }
    }

    @media (max-width: 1024px) {
      flex: auto;
      flex-shrink: 10;
      flex-grow: 0;
      font-size: var(--font-l);
      margin-inline-end: var(--margin-l);
      margin-inline-start: var(--margin-l);
    }

    @media (max-width: 767px) {
      margin-bottom: 0;
      padding-bottom: var(--margin-m);
    }
    @media (max-width: 380px) {
      flex: 200px;
      flex-shrink: 10;
      flex-grow: 0;
      margin-inline-end: 0;
      margin-inline-start: 0;
      margin-bottom: 0;
    }
  }

  .options-title {
    font-size: var(--font-2xl);
    margin-bottom: var(--margin-xm);
    @media (max-width: 767px) {
      font-size: var(--font-xl);
      margin-bottom: var(--margin-m);
    }
  }

  .options-container {
    gap: var(--margin-xl);

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .option {
    min-height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: var(--margin-l);
    flex: 240px;
    padding: var(--margin-xl);

    @media (max-width: 767px) {
      //flex-wrap: wrap;
      min-height: 80px;
      height: auto;
      flex: auto;
      min-width: 360px;
      max-width: 360px;
      margin-inline: auto;
      flex-direction: row;
      padding: var(--margin-m) var(--margin-l);
    }

    @media (max-width: 500px) {
      min-width: 320px;
      max-width: 320px;
    }

    &__content {
      flex: 100%;

      .button {
        width: 120px;
        margin: 0 auto var(--margin-s) auto;
      }
    }

    &__text {
      @media (max-width: 767px) {
        flex: 0 0 100%;
        text-align: center;
      }
    }

    .item-icon {
      height: 65px;
      width: 65px;
      flex: 0 0 65px;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      @media (max-width: 767px) {
        align-items: center;
      }

      img {
        object-fit: contain;
      }
    }

    &:hover {
      text-decoration: none;

      .button {
        background-color: var(--c-bg);
        border-color: var(--c-lead);
        color: var(--c-lead);
      }
    }
  }

  //legal override
  .legal {
    p {
      @media (max-width: 500px) {
        text-align: start;
      }
    }
  }
}
</style>
